/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBadgeDot from "components/MDBadgeDot";
import PieChart from "examples/Charts/PieChart";

interface Props {
  grades: { grade: string, count: number }[]
}

function SubCategoriesPerGradeChartChart({ grades }: Props): JSX.Element {
  const colors = ["#ffe12a", "#f54c5b", "#cb6efe", "#8fdc9c", "#00b9f8", "#ff8445"];

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
        <MDTypography variant="h6">Subcategories per Grade</MDTypography>
      </MDBox>
      <MDBox mt={3}>
        <Grid container alignItems="center">
          <Grid item xs={7}>
            <PieChart chart={{
              labels: grades.map(grade => grade.grade),
              datasets: {
                label: "Categories",
                backgroundColors: grades.map((grade, index) => colors[index]),
                data: grades.map(grade => grade.count),
              },
            }} height="12.5rem" />
          </Grid>
          <Grid item xs={5}>
            <MDBox pr={1}>
              {grades.map( (grade, index) =>
                <MDBox key={index} mb={1}>
                  <MDBadgeDot color={colors[index]} size="sm" badgeContent={grade.grade} notFlex complement={`${grade.count} subcategories`} />
                </MDBox>
              )}
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default SubCategoriesPerGradeChartChart;
